// extracted by mini-css-extract-plugin
module.exports = {"inner":"insights_box-module__inner--2G2Rk","innerNoStroke":"insights_box-module__innerNoStroke--2t3CQ"};